import makeStyles from "@material-ui/core/styles/makeStyles";
export default makeStyles(theme => ({
  table: ({ type }) => ({
    borderCollapse: "unset",
    // padding: "0 3px",
    borderSpacing: type === "border" ? "0" : "0 6px",
    border: "none",
    minHeight: theme.spacing(62)
  }),
  tableHead: ({ type }) => ({
    "& tr": {
      "& th": {
        cursor: "default",
        backgroundColor:
          type === "default"
            ? "transparent"
            : theme.palette.background.tableRowHead,
        color: theme.palette.background.tableRowHeadText,
        position: "relative",
        top: type === "border" || type === "default" ? "0" : "6px",

        [theme.breakpoints.down("sm")]: {
          backgroundColor: [theme.palette.background.tableRowHead, "!important"]
        },
        "&:last-child": {
          [theme.breakpoints.down("sm")]: {
            backgroundColor: [theme.palette.background.main, "!important"]
          }
        }
      }
    }
  }),

  tableRow: ({ cursorType }) => ({
    cursor: cursorType === "pointer" && "pointer",
    display: "table-row",
    outline: "0",
    verticalAlign: "middle",
    backgroundColor: theme.palette.background.tableRow,
    transition: theme.palette.transition2,
    boxShadow: theme.palette.shadow1,
    "&:hover": {
      boxShadow: theme.palette.shadow2
    },
    "&.MuiTableRow-head": {
      background: "transparent",
      boxShadow: "none",
      "&:hover": {
        background: "transparent",
        boxShadow: "none"
      }
    }
  }),
  tableCell: ({ type }) => ({
    borderBottom: type === "border" ? "1px solid #f4f6fc" : "none",
    whiteSpace: type === "default" ? "normal" : "nowrap",
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap"
    }
  }),
  lastFixed: ({ type }) => ({
    position: type === "default" ? "relative" : "sticky",
    right: type === "default" ? "auto" : "0",
    backgroundColor:
      type === "default" ? "transparent" : theme.palette.background.tableRow,
    boxShadow: type === "default" ? "none" : "-2px 2px 4px 0 rgba(0,0,0,0.1)",
    [theme.breakpoints.down("sm")]: {
      position: "sticky",
      backgroundColor: theme.palette.background.tableRow,
      right: "0",
      boxShadow: "-2px 2px 4px 0 rgba(0,0,0,0.1)"
    }
  }),
  firstFixedHead: {
    backgroundColor: [theme.palette.background.main, "!important"]
  },
  lastFixedHead: ({ type }) => ({
    position: type === "default" ? "relative" : "sticky !important",
    top: type === "default" ? "6px" : "12px !important",
    right: type === "default" ? "auto" : "0",
    backgroundColor: [theme.palette.background.main, "!important"],
    [theme.breakpoints.down("sm")]: {
      position: "sticky !important",
      right: "0"
    }
  }),
  pagination: {
    marginTop: theme.spacing(10),
    display: "flex",
    justifyContent: "flex-end",
    "& nav": {
      backgroundColor: theme.palette.white.main,
      borderRadius: theme.spacing(2),
      boxShadow: theme.palette.shadow1,
      padding: theme.spacing(3, 7)
    },
    "& .MuiPaginationItem-page": {
      border: "none",
      backgroundColor: "inherit",
      color: theme.palette.secondary.tint40,
      width: [theme.spacing(5), "!important"],
      minWidth: [theme.spacing(5), "!important"],
      height: theme.spacing(12),
      margin: theme.spacing(0, 5),
      borderBottom: `3px solid transparent`
    },
    alignItems: "center",
    "& .Mui-selected": {
      pointerEvents: "none",
      cursor: "no-drop !important",
      backgroundColor: [theme.palette.white.main, "!important"],
      color: theme.palette.secondary.main,
      borderRadius: 0,
      borderBottom: `3px solid ${theme.palette.primary.tint100}`
    },
    "& li:first-child": {
      display: "block !important"
    },
    "& li:last-child": {
      display: "block !important"
    }
  }
}));
